export interface RequestTypeConfig {
    country: string;
    requestTypes: string[];
    requiredSubtypes: string[];
    subtypes: string[];
}

// Request types that allow future-dated end dates (forward-looking surveillance
// orders such as PR/TT and Lawful Intercept). Shared by V2 Domestic
// (LegalOrderDetailsStep) and V2 International (InternationalTypeOfServiceStep).
export const REQUEST_TYPES_WITH_DATE_OVERRIDE: readonly string[] = ['PR/TT', 'Lawful Intercept'];

// "E-Evidence" is an EU-only Request Type. Its sub-types are the EPOC variants,
// giving a direct RequestType/RequestSubType enumeration mapping into CRM.
export const E_EVIDENCE_REQUEST_TYPE = 'E-Evidence';

export const EPOC_SUBTYPES: readonly string[] = [
    'EPOC',
    'EPOC Emergency',
    'EPOC with Notification',
    'EPOC Preservation',
];

export const REQUEST_TYPE_CONFIGS: RequestTypeConfig[] = [
    {
        country: 'USA',
        requestTypes: ['Subpoena or Summons', 'Court Order', 'Search Warrant', 'PR/TT', 'Lawful Intercept', 'Emergency Letter', 'Other'],
        requiredSubtypes: ['PR/TT', 'Lawful Intercept'],
        subtypes: ['Renewal', 'Start', 'Stop'],
    },
    {
        country: 'Ireland',
        requestTypes: ['International Order', 'International MLAT', 'Irish Court Order', 'Emergency'],
        requiredSubtypes: [],
        subtypes: [],
    },
    {
        country: 'Brazil',
        requestTypes: ['Lawful Intercept', 'International Order', 'Emergency'],
        requiredSubtypes: ['Lawful Intercept'],
        subtypes: ['Renewal', 'Start', 'Stop'],
    },
    {
        country: 'Other International',
        requestTypes: ['International Order', 'Emergency', 'Other'],
        requiredSubtypes: [],
        subtypes: [],
    },
];

export const DEFAULT_REQUEST_TYPE_CONFIG: RequestTypeConfig = {
    country: 'Other International',
    requestTypes: ['International Order', 'Emergency', 'Other'],
    requiredSubtypes: [],
    subtypes: [],
};

export function getRequestTypeConfigForCountry(countryName: string): RequestTypeConfig {
    const config = REQUEST_TYPE_CONFIGS.find(
        (c) => c.country.toLowerCase() === countryName.toLowerCase()
    );
    return config || DEFAULT_REQUEST_TYPE_CONFIG;
}

export function isSubtypeRequired(countryName: string, requestType: string): boolean {
    const config = getRequestTypeConfigForCountry(countryName);
    return config.requiredSubtypes.some(
        (rt) => rt.toLowerCase() === requestType.toLowerCase()
    );
}

export function getSubtypesForCountry(countryName: string): string[] {
    const config = getRequestTypeConfigForCountry(countryName);
    return config.subtypes;
}

export function getRequestTypesForCountry(countryName: string): string[] {
    const config = getRequestTypeConfigForCountry(countryName);
    return config.requestTypes;
}
